import { useQuery, QueryFunction } from 'react-query';
import {
    DailyTruckRide,
    TonnageByDriver,
    GetDailyTrucksRidesQueries,
    GetTonnageByDriverQuery,
    getDailyTrucksRides,
    getTonnageByDriver,
} from '../../services/apiSLTP/dailyReports/dailyTrucksRides';

type UseDailyTrucksRidesQueryOptions = {
    query: GetDailyTrucksRidesQueries;
};

const getDailyTrucksRidesQuery: QueryFunction<DailyTruckRide[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseDailyTrucksRidesQueryOptions];
    const { query } = options;

    const response = await getDailyTrucksRides(query);
    return response.data;
};

export const useDailyTrucksRidesQuery = (options: UseDailyTrucksRidesQueryOptions) => {
    return useQuery(['dailyTrucksRides', options], getDailyTrucksRidesQuery);
};

type UseTonnageByDriverQueryOptions = {
    queries: GetTonnageByDriverQuery;
};

const TonnageByDriverQuery: QueryFunction<TonnageByDriver[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseTonnageByDriverQueryOptions];
    const { queries } = options;

    const response = await getTonnageByDriver(queries);
    return response.data;
};

export const useTonnageByDriverQuery = (options: UseTonnageByDriverQueryOptions) => {
    return useQuery(['TonnageByDriver', options], TonnageByDriverQuery);
};
